import styled from "styled-components";

export const TableSpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
`;
